

require('./styles');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

define(['squid/index', 'text!./template.html', '../cart/directive', 'components/xo-ui-components/src/escape-hatch/closeFrame/directive', 'components/xo-form-components/src/language-options/directive'], function (squid, template) {
    squid.module('xo-header.directive', ['squid', 'xo-cart.directive', 'xo-escape-hatch.closeFrame.directive', 'xo-language-options.directive']).directive('xoHeader', function () {
        return {
            template: template,
            scope: {
                showCartTotal: '=',
                renderCartContainer: '=',
                token: '=',
                isUnbranded: '=',
                unbrandedTitle: '=',
                unbrandedSubTitle: '=',
                languageSwitch: '=?',
                redirectiframe: '=',
                redirectLightbox: '='
            },
            controller: function controller($scope, $rootScope, $renderContent) {
                $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
                _logger.$logger.info('IS_MESSENGER_BA_INTEGRATION: on header ' + $scope.isMessengerBAIntegration);
                // $util.assert($scope.token, 'Expected token');
                $scope.title = $renderContent($scope.unbrandedTitle);
                $scope.subTitle = $renderContent($scope.unbrandedSubTitle);
            }
        };
    });
});

_squid.$integration;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/header/directive.js
// module id = ./components/xo-page-components/src/header/directive.js
// module chunks = 1